var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "brick-square-base",
    { staticClass: "journey-brick", class: _vm.classList },
    [
      _c(
        "journey-builder-composer-touchpoint-overview",
        {
          ref: "overview",
          attrs: {
            "brick-id": _vm.id,
            "brick-name": _vm.name,
            "brick-type": _vm.type,
            "brick-config": _vm.config,
            "brick-is-new": _vm.isNew,
            "incoming-connections-info": _vm.IncomingConnectionsInfo,
            "outgoing-connections-info": _vm.OutgoingConnectionsInfo
          }
        },
        [
          [
            _c(
              "div",
              { staticClass: "brick-menu" },
              [
                _c("journey-brick-menu", {
                  attrs: {
                    "is-active": _vm.isActive,
                    "has-connections": _vm.hasConnections,
                    "brick-type": _vm.type,
                    "is-child-journey-brick": _vm.isChildJourneyBrick
                  },
                  on: {
                    "info-click": function($event) {
                      return _vm.showOverview()
                    },
                    "add-connection-click": function($event) {
                      return _vm.$emit("add-connection", $event)
                    },
                    "delete-click": function($event) {
                      return _vm.$emit("delete-brick", true)
                    },
                    "settings-click": function($event) {
                      _vm.showSettings = true
                    }
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "brick-icon" }, [
              _c("i", { class: _vm.icon })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "brick-title" }, [
              _c("span", { staticClass: "center" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.name) +
                    "\n                "
                )
              ])
            ]),
            _vm._v(" "),
            _vm.showSettings
              ? _c(_vm.editorType, {
                  tag: "component",
                  attrs: {
                    value: _vm.config,
                    name: _vm.name,
                    show: _vm.showSettings,
                    availableConditions: _vm.availableConditions
                  },
                  on: {
                    hide: function($event) {
                      _vm.showSettings = false
                    },
                    save: function($event) {
                      return _vm.$emit("settings-changed", $event)
                    },
                    delete: function($event) {
                      return _vm.$emit("delete-brick", false)
                    }
                  }
                })
              : _vm._e()
          ]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }